import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const propertyPolicyConfig = {
  /* ------------------------------- GET ---------------------------------- */

  getAllPropertyPolicies: {
    key: "getAllPropertyPolicies",
    url: "/api/v1/property-policy",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getDeletedPropertyPolicies: {
    key: 'getDeletedPropertyPolicies',
    url: '/api/v1/property-policy/deleted',
    method: 'GET',
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  restorePropertyPolicy: {
    key: 'restorePropertyPolicy',
    url: (data) => `/api/v1/property-policy/${data.id}/restore`,
    method: 'POST',
    options: {
      retry: 2,
      invalidateKeys: ['getAllPropertyPolicies', 'getDeletedPropertyPolicies'],
      onSuccessMessage: 'Property policy restored successfully',
      onErrorMessage: 'Failed to restore property policy',
    },
  },

  getPropertyPolicyById: {
    key: "getPropertyPolicyById",
    url: (data) => `/api/v1/property-policy/${data.id}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  createPropertyPolicy: {
    key: "createPropertyPolicy",
    url: "/api/v1/property-policy",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllPropertyPolicies"],
      onSuccessMessage: "Property policy created successfully",
      onErrorMessage: "Failed to create property policy",
    },
  },

  /* ------------------------------- PUT ---------------------------------- */

  updatePropertyPolicy: {
    key: "updatePropertyPolicy",
    url: (data) => `/api/v1/property-policy/${data.id}`,
    method: "PUT",
    options: {
      retry: 2,
      invalidateKeys: ["getAllPropertyPolicies", "getPropertyPolicyById"],
      onSuccessMessage: "Property policy updated successfully",
      onErrorMessage: "Failed to update property policy",
    },
  },

  /* ------------------------------- PATCH ---------------------------------- */

  togglePropertyPolicyStatus: {
    key: "togglePropertyPolicyStatus",
    url: (data) => `/api/v1/property-policy/${data.id}/toggle-status`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getAllPropertyPolicies", "getPropertyPolicyById"],
      onSuccessMessage: "Property policy status updated successfully",
      onErrorMessage: "Failed to update property policy status",
    },
  },

  /* ------------------------------- DELETE ---------------------------------- */

  deletePropertyPolicy: {
    key: "deletePropertyPolicy",
    url: (data) => `/api/v1/property-policy/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getAllPropertyPolicies", "getDeletedPropertyPolicies"],
      onSuccessMessage: "Property policy deleted successfully",
      onErrorMessage: "Failed to delete property policy",
    },
  },
};
